export const uploadFileObj = {
    //上传文件
    upLoadFile(that, fileList, sucFunc, errorFunc) {
        let formData = new FormData();
        fileList.forEach(file => {
            formData.append('file', file);
        });
        formData.append('type', 1);
        that.$api
            .fileUpload(formData)
            .then((res) => {
                if (commonObj.isServiceCallSuccess(res.code)) {
                    let returnfile = [];
                    if (res.data) {
                        returnfile = res.data.split(',');
                    }
                    sucFunc && sucFunc(returnfile);
                } else {
                    errorFunc && errorFunc(res.msg);
                }
            })
            .catch((err) => {
                errorFunc && errorFunc(err);
            });
    },
}


// WEBPACK FOOTER //
// ./src/commonjs/uploadFile.js